import { HttpErrorResponse } from '@angular/common/http';
import {Component, Inject, ViewChild} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import {DuplicateContactModel} from '../../api/models/duplicate-contact-model';
import {MatConfirmDialogComponent} from '../../dialogs/mat-confirm/mat-confirm-dialog.component';
import {ContactService} from '../contact.service';
import {ContactDuplicatesListComponent} from './list.component';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

export interface DuplicateContactsDialogData {
  contactType: string;
}

@Component({
    selector: 'app-duplicate-contacts-dialog',
    template: `
    <div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
      <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px;">
        <div fxFlex>Duplicate Contacts</div>
        <button mat-icon-button [mat-dialog-close]="false" class="button-40">
          <mat-icon>close</mat-icon>
        </button>
      </h1>
      <div mat-dialog-content fxFlex>
        <app-duplicate-contacts-list fxFlex
                                     [contactType]="contactType"
                                     (onDuplicatesSelected)="onDuplicatesSelected($event)"></app-duplicate-contacts-list>
      </div>
      <div mat-dialog-actions align="end" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
        <div *ngIf="deleteInProgress" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
          <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
          <span>Deleting</span>
        </div>

        <button mat-button color="warn" *ngIf="!deleteInProgress && !!this.selectedDuplicates && this.selectedDuplicates.length"
                (click)="deleteConfirmPopup()">
          Delete Selected ({{ this.selectedDuplicates?.length }})
        </button>
        <button mat-button (click)="closeSendConfirmPopup('close')">Close</button>
      </div>
    </div>
  `,
    styles: [
        '.thread-list {height: 100%; padding: 0;}',
        '.thread-list:focus {border: none; outline: none}',
        '.thread-viewport {height: 100%}',
    ],
    standalone: true,
    imports: [FlexModule, MatDialogTitle, MatIconButton, MatDialogClose, MatIcon, CdkScrollable, MatDialogContent, ContactDuplicatesListComponent, MatDialogActions, NgIf, MatProgressSpinner, MatButton]
})
export class DuplicatesDialogComponent {

  selectedDuplicates: Array<DuplicateContactModel> = [];
  deleteInProgress = false;
  deleteProgress = 0;
  contactType = '-1';

  @ViewChild(ContactDuplicatesListComponent, { static: false }) duplicateList: ContactDuplicatesListComponent;

  constructor(public dialogRef: MatDialogRef<DuplicatesDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DuplicateContactsDialogData,
              public dialog: MatDialog,
              public contactService: ContactService,
  ) {
    this.contactType = data.contactType;
  }

  closeSendConfirmPopup(action: string) {
    this.dialogRef.close(action);
  }

  deleteConfirmPopup() {
    const dialogRef = this.dialog.open(MatConfirmDialogComponent, {
      // width: '250px',
      // height: '90%',
      data: {
        title: 'Delete selected contacts',
        actionTitle: 'Delete',
        text: 'Are you sure you want to delete selected contacts?',
        hideCancel: false
      }
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        this.deleteInProgress = true;
        this.deleteProgress = 0;
        console.log('start delete');
        const selectedIds = this.selectedDuplicates.map(d => d.id);
        const selectedUniqueIds = Array.from(new Set(selectedIds));

        await this.contactService.saveContacts({
          deleteEnabled: true,
          ids: selectedUniqueIds,
          filter: {
            skip: 0,
            limit: 100,
          },
          syncWithPbx: false,
          tags: [],
          syncWithPbxEnabled: false,
          tagsEnabled: false,
          tagsMergeType: 'replace',
          updateAll: false,
        });

        this.duplicateList.getDuplicateContactsListData().finally(() => {
          this.deleteInProgress = false;
          this.deleteProgress = 0;
          this.selectedDuplicates = [];
        });

        console.log('end delete');
      }
    });
  }

  onDuplicatesSelected($event: Array<DuplicateContactModel>) {
    this.selectedDuplicates = $event || [];
  }
}
